// 婚姻届のダウンロードページに、くふう marry の「結婚イベントスタイル診断」を iframe で埋め込む
// メッセージの仕様: https://github.com/kufu-ai/anymarry-kufu-marry/blob/main/docs/diagnosis_embed.md
const RESULT_COOKIE_MAX_AGE = 60 * 60 * 24 * 365
// 埋め込みを拒否された(frame-ancestors)・marry が落ちているなどでメッセージが来ないとき、
// 空の枠のままダウンロードできなくならないよう、この時間で診断を諦めてダウンロードを出す
const HANDSHAKE_TIMEOUT_MS = 10000

const findRoot = () => document.querySelector('[data-diagnosis-state]')
const findIframe = () => document.querySelector('[data-diagnosis-iframe]')

let handshakeTimer = null
// 前回の結果から始めるときは、DOMContentLoaded より前に最初のメッセージが届くことがある
let isIframeAlive = false

const setState = (root, state) => {
  root.dataset.diagnosisState = state
  root.querySelectorAll('[data-diagnosis-visible]').forEach((element) => {
    element.hidden = !element.dataset.diagnosisVisible.split(' ').includes(state)
  })
}

// cookie 名はサーバーが読むものと同じ値を data 属性で受け取る(Konintodoke::Diagnosis::RESULT_COOKIE_KEY)
const saveResult = (iframe, characterKey) => {
  const secure = window.location.protocol === 'https:' ? '; secure' : ''
  document.cookie = `${iframe.dataset.diagnosisCookieKey}=${encodeURIComponent(characterKey)}; path=/konintodoke; max-age=${RESULT_COOKIE_MAX_AGE}; samesite=lax${secure}`
}

const waitForHandshake = (root, iframe) => {
  if (isIframeAlive || handshakeTimer !== null) return

  handshakeTimer = window.setTimeout(() => {
    console.warn(`[diagnosis-embed] ${iframe.dataset.diagnosisOrigin} から応答が無いため、診断を表示せずにダウンロードを出します`)
    // 枠ごと外す。前回の結果から始めたときは、ダウンロードはすでに出ているので枠を消すだけでよい
    iframe.closest('.konintodoke-diagnosis__embed').remove()
    if (root.dataset.diagnosisState === 'diagnosing') setState(root, 'unavailable')
  }, HANDSHAKE_TIMEOUT_MS)
}

const markAlive = (iframe) => {
  if (isIframeAlive) return

  isIframeAlive = true
  window.clearTimeout(handshakeTimer)
  iframe.closest('.konintodoke-diagnosis__embed').classList.remove('-waiting')
}

// iframe が読み込み直後に送る高さを取りこぼさないよう、DOM の準備を待たずに登録する
window.addEventListener('message', (event) => {
  const iframe = findIframe()
  if (!iframe) return
  // marry 以外のサイトや、他の iframe から届いたメッセージは無視する
  if (event.origin !== iframe.dataset.diagnosisOrigin || event.source !== iframe.contentWindow) return

  markAlive(iframe)

  const message = event.data || {}
  // 中身を描く前に 0 が届くことがあり、そのまま反映すると枠が消えるので無視する
  if (message.type === 'kufumarry:diagnosis:height' && Number.isFinite(message.height) && message.height > 0) {
    iframe.style.height = `${message.height}px`
  }
  if (message.type === 'kufumarry:diagnosis:result' && typeof message.characterKey === 'string') {
    saveResult(iframe, message.characterKey)

    const root = findRoot()
    if (root.dataset.diagnosisState !== 'result') {
      setState(root, 'result')
      window.scrollTo(0, 0)
    }
  }
})

// iOS Safari では、ブラウザバックでキャッシュ(bfcache)から復元したページの診断の iframe がタップを受け付けない。
// 再読み込みすると直るので、復元されたときだけ読み込み直す。前回の結果は cookie にあるので結果から始まる。
// 入口ではまだ iframe を読み込んでいないので、読み込み直さない
window.addEventListener('pageshow', (event) => {
  if (event.persisted && findIframe()?.getAttribute('src')) window.location.reload()
})

document.addEventListener('DOMContentLoaded', () => {
  const root = findRoot()
  if (!root) return

  const iframe = findIframe()
  // 前回の結果から始めるときは、表示した時点で iframe を読み込んでいる
  if (iframe.getAttribute('src')) waitForHandshake(root, iframe)

  root.querySelectorAll('[data-diagnosis-start]').forEach((button) => {
    button.addEventListener('click', () => {
      // 連打で読み込み直さない
      if (root.dataset.diagnosisState !== 'intro') return

      iframe.src = iframe.dataset.diagnosisStartUrl
      setState(root, 'diagnosing')
      window.scrollTo(0, 0)
      waitForHandshake(root, iframe)
    })
  })

  // 開始ボタンが効くようになったので、JS が動かないとき用の PDF へのリンクを外す。
  // 途中で例外が出たときはここまで来ないので、リンクは残る
  root.querySelectorAll('[data-diagnosis-no-js-fallback]').forEach((link) => link.remove())
})
